/**
 * Show nav li active state on posts depending on current post category meta field
 */

jQuery(document).ready(function() {

    if ($('body').hasClass('single')) {

        // Get class from data holder element
        // Class set with php
        var elCat = $('#category-archive-page').attr("class");

        // Find first nav item with same class to prevent multiple active li items
        // Class set with theme-setup filter
        var navCat = $('.main-navigation').find('.'+elCat).first(); 

        if (elCat.length > 0 && navCat.length > 0) {

            $(navCat).addClass('current-menu-item'); // show li as active

            var liParent = $(navCat).closest("li:not(.current-menu-item)");

            if (liParent.length > 0) { // show li parent as active
                $(liParent).addClass('current-menu-ancestor');
            }

            var liAncestor = $(liParent).closest("li:not(.current-menu-ancestor)");

            if (liAncestor.length > 0) { // show li ancestor as active
                $(liAncestor).addClass('current-menu-ancestor');
            }

        }

    }

});